import { URL, handleErrors } from "./depannageActions"
import { getParams } from "../../utilities/Addons"
import { showToast } from "./toastActions"
import { catchApiError } from "./apiHelpers"

export const FETCH_AGENDA_BEGIN = "FETCH_AGENDA_BEGIN"
export const FETCH_AGENDA_SUCCESS = "FETCH_AGENDA_SUCCESS"
export const FETCH_AGENDA_ERROR = "FETCH_AGENDA_ERROR"
export const FETCH_AGENDA_RESET = "FETCH_AGENDA_RESET"

export const fetchAgendaBegin = () => ({
	type: FETCH_AGENDA_BEGIN,
})

export const fetchAgendaSucces = (addresses) => ({
	type: FETCH_AGENDA_SUCCESS,
	payload: addresses,
})

export const fetchAgendaError = (error) => ({
	type: FETCH_AGENDA_ERROR,
	payload: { error },
})

export const fetchAgendaReset = () => ({
	type: FETCH_AGENDA_RESET,
})

// --- Rendez-vous (Rdv) : CRUD api/rdvs --------------------------------------
export const FETCH_RDVS_BEGIN = "FETCH_RDVS_BEGIN"
export const FETCH_RDVS_SUCCESS = "FETCH_RDVS_SUCCESS"
export const FETCH_RDVS_ERROR = "FETCH_RDVS_ERROR"
export const POST_RDV_BEGIN = "POST_RDV_BEGIN"
export const POST_RDV_SUCCESS = "POST_RDV_SUCCESS"
export const POST_RDV_ERROR = "POST_RDV_ERROR"
export const POST_RDV_RESET = "POST_RDV_RESET"
export const DELETE_RDV_BEGIN = "DELETE_RDV_BEGIN"
export const DELETE_RDV_SUCCESS = "DELETE_RDV_SUCCESS"
export const DELETE_RDV_ERROR = "DELETE_RDV_ERROR"
export const DELETE_RDV_RESET = "DELETE_RDV_RESET"

export const postRdvReset = () => ({ type: POST_RDV_RESET })
export const deleteRdvReset = () => ({ type: DELETE_RDV_RESET })

const jsonHeaders = (token) => ({
	Accept: "application/json, text/plain",
	"Content-type": "application/json",
	Authorization: `Bearer ${token}`,
})

// Liste des Rdv de la plage [start, end[ (ISO), pour la semaine affichée.
export function fetchRdvs({ start, end }) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: FETCH_RDVS_BEGIN })
		const url = `${URL}api/rdvs${getParams({ start, end })}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch({ type: FETCH_RDVS_SUCCESS, payload: json }))
			.catch(
				catchApiError(dispatch, (payload) => ({
					type: FETCH_RDVS_ERROR,
					payload,
				})),
			)
	}
}

// Création / édition d'un Rdv (create si pas d'id). Renvoie le Rdv sauvegardé.
export function postRdv(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: POST_RDV_BEGIN })
		return fetch(`${URL}api/rdvs`, {
			method: "post",
			headers: jsonHeaders(token),
			body: JSON.stringify(data),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch({ type: POST_RDV_SUCCESS, payload: json })
				dispatch(showToast("success", "Sauvegarde terminée."))
				return json
			})
			.catch(
				catchApiError(dispatch, (payload) => ({
					type: POST_RDV_ERROR,
					payload,
				})),
			)
	}
}

export function deleteRdv(body) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: DELETE_RDV_BEGIN })
		return fetch(`${URL}api/rdvs`, {
			method: "delete",
			headers: jsonHeaders(token),
			body: JSON.stringify(body),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch({ type: DELETE_RDV_SUCCESS, payload: json })
				dispatch(showToast("success", "Rendez-vous supprimé."))
				return json
			})
			.catch(
				catchApiError(dispatch, (payload) => ({
					type: DELETE_RDV_ERROR,
					payload,
				})),
			)
	}
}

export function fetchAgenda(params) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchAgendaBegin())
		let url = `${URL}api/agenda${getParams(params)}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchAgendaSucces(json))
			})
			.catch(catchApiError(dispatch, fetchAgendaError))
	}
}

// Recherche d'entités (clients) pour l'autocomplete de l'agenda. Résout vers le
// tableau d'entités ({id, label, nom, prenom, type, type_label, telephone,
// display}) — résultats transitoires, pas de slice reducer. Silencieux en cas
// d'erreur (l'autocomplete ne doit pas spammer de toasts à chaque frappe).
export function searchEntites(query) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		const q = (query || "").trim()
		if (!q) return []
		let url = `${URL}api/entites/search${getParams({ q })}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => json.entites || [])
			.catch(() => [])
	}
}

// Véhicules d'une entité (pour le select véhicule du RDV). Résout vers le tableau
// `entite.vehicules` (id, plaques, marque, modele, …) — transitoire, pas de slice.
export function fetchEntiteVehicules(id) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		if (!id) return []
		const url = `${URL}api/entites?id=${id}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => json.vehicules || [])
			.catch(() => [])
	}
}
